/* eslint-disable no-nested-ternary */
/* eslint-disable prefer-destructuring */
import React, { useEffect, useState } from "react";
import useSkus from "hooks/useSkus";
import { Input, Typography } from "design_system/src";
import { useMediaQuery } from "@mui/material";
import { SelectedSkuFilters, SkuSortTypeEnum } from "models/inventory/helpers/skuFilters.helpers";

interface Props {
  onChange: (changes: Partial<SelectedSkuFilters>) => void;
}

const SortSkus: React.FC<Props> = ({ onChange }) => {
  const { selectedFilters: { sort } = {} } = useSkus();
  const matchesXS = useMediaQuery("(min-width:600px)");

  const orderOptions = [
    { value: SkuSortTypeEnum.LOWER_PRICE, label: "Precio más bajo" },
    { value: SkuSortTypeEnum.HIGHER_PRICE, label: "Precio más alto" },
    { value: SkuSortTypeEnum.HIGHER_CC, label: "Mayor CC" },
    { value: SkuSortTypeEnum.LOWER_CC, label: "Menor CC" },
  ];

  const [selectedOption, setSelectedOption] = useState<SkuSortTypeEnum>(sort ?? SkuSortTypeEnum.LOWER_PRICE);

  const handleSelectChange = (e: any) => {
    const value = e.target.value;
    setSelectedOption(value);
    onChange({ sort: value !== "" ? value : undefined });
  };

  useEffect(() => {
    setSelectedOption(sort ?? SkuSortTypeEnum.LOWER_PRICE);
  }, [sort]);

  return (
    <div className={`display_flex ${!matchesXS ? " flex_col" : " flex_align_center"}`}>
      <Typography
        scale="small"
        weight="400"
        className="text_neutral_600 m_r_sm"
        style={{ marginBottom: matchesXS ? 0 : "-1rem" }}
      >
        Ordenar por:
      </Typography>
      <Input
        title=""
        placeholder=""
        name="sortSkus"
        type="select"
        options={orderOptions}
        className="inputSelect"
        value={selectedOption}
        onChange={handleSelectChange}
      />
    </div>
  );
};

export default SortSkus;
